import { createContext } from "react";

const exersizeContext = createContext()

export default exersizeContext;